@if (productData) {
<div class="subnav bg-gray-100">
    <div class="container pt-1 pt-lg-3 pb-1">
        <div class="row gy-2">
            <div class="col-12 col-sm">
                <div
                    class="product-name"
                    [ngClass]="{ 'd-flex align-items-center h-100': !productData.activeConsole?.['webDisplayName'] }"
                >
                    <p
                        [innerHTML]="webDisplayName"
                        class="lead mb-0 text-white"
                    ></p>
                    @if (productData.activeConsole?.['webDisplayName']) {
                    <div class="console pl-0 mb-0">
                        <p
                            [innerHTML]="
                                'PRODUCT-PAGE_GLOBAL_CONSOLE-WITH_TEXT'
                                    | translate
                            "
                            class="d-inline mb-0 small text-tertiary"
                        ></p>
                        <p
                            [innerHtml]="productData.activeConsole?.['webDisplayName']"
                            class="d-inline mb-0 small text-tertiary"
                        ></p>
                    </div>
                    }
                </div>
            </div>
            <div class="col-12 col-sm text-start text-md-end">
                <div class="request-quote">
                    <button
                        (click)="openModal('requestQuote')"
                        [innerHTML]="
                            'PRODUCT-PAGE_GLOBAL_REQUEST-A-QUOTE_TEXT'
                                | translate
                        "
                        [ngClass]="'btn btn-outline-tertiary'"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</div>
}
